// Shared recharts styling for the scored dashboard (SVG, so CSS variables, not
// Tailwind classes). Mirrors the axis/tooltip treatment in ../components/charts.tsx.

export const AXIS_PROPS = {
  stroke: 'var(--color-border)',
  tick: { fill: 'var(--color-muted-foreground)', fontSize: 11 },
  tickLine: false,
} as const;

export const GRID_PROPS = {
  stroke: 'var(--color-border)',
  strokeDasharray: '3 3',
  vertical: false,
} as const;

export const TOOLTIP_PROPS = {
  contentStyle: {
    background: 'var(--color-card)',
    border: '1px solid var(--color-border)',
    borderRadius: 'var(--radius-md)',
    color: 'var(--color-card-foreground)',
    fontSize: 12,
  },
  labelStyle: { color: 'var(--color-muted-foreground)' },
  itemStyle: { color: 'var(--color-card-foreground)' },
} as const;

/** Categorical series colours (s1..s5 in the prototype). */
export const SERIES = [
  'var(--color-series-1)',
  'var(--color-series-2)',
  'var(--color-series-3)',
  'var(--color-series-4)',
  'var(--color-series-5)',
] as const;

/** Use on every recharts series: operational readouts shouldn't animate on each scope change. */
export const NO_ANIM = { isAnimationActive: false } as const;
